var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(-556.5 -712.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1375-2",
    "data-name": "Group 1375",
    transform: "translate(557 713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stats-chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M50.7,313.262H49.158A1.158,1.158,0,0,1,48,312.1v-6.946A1.158,1.158,0,0,1,49.158,304H50.7a1.158,1.158,0,0,1,1.158,1.158V312.1A1.158,1.158,0,0,1,50.7,313.262Z",
    transform: "translate(-48 -289.262)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M274.7,221.893h-1.544A1.158,1.158,0,0,1,272,220.735V209.158A1.158,1.158,0,0,1,273.158,208H274.7a1.158,1.158,0,0,1,1.158,1.158v11.577A1.158,1.158,0,0,1,274.7,221.893Z",
    transform: "translate(-258.573 -197.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M386.7,115.3h-1.544A1.158,1.158,0,0,1,384,114.138V97.158A1.158,1.158,0,0,1,385.158,96H386.7a1.158,1.158,0,0,1,1.158,1.158v16.98A1.158,1.158,0,0,1,386.7,115.3Z",
    transform: "translate(-363.859 -91.296)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M162.7,40h-1.544A1.179,1.179,0,0,1,160,38.8V17.2a1.179,1.179,0,0,1,1.158-1.2H162.7a1.179,1.179,0,0,1,1.158,1.2V38.8A1.179,1.179,0,0,1,162.7,40Z",
    transform: "translate(-153.286 -16)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/stats-icon.633f8a1086d6c8751e5d3a16fb6eb7bb.svg";
export { ForwardRef as ReactComponent };